export enum PaymentLinkStatus {
  OPEN = "OPEN",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}
